import { useSearchParams } from 'next/navigation';
import { useMemo } from 'react';

type ValidatorFn = (value: string | null | undefined) => boolean;

export type SearchParamsFilterParams = [string, ValidatorFn?][];

export const useSearchParamsFilter = (
  whitelistedParams: SearchParamsFilterParams,
): string => {
  const searchParams = useSearchParams();

  return useMemo(() => {
    const result = new URLSearchParams();

    for (const [paramKey, validatorFn] of whitelistedParams) {
      const paramValue = searchParams.get(paramKey);

      if (
        searchParams.has(paramKey) &&
        (!validatorFn || (!!validatorFn && validatorFn(paramValue)))
      ) {
        result.set(paramKey, String(paramValue));
      }
    }

    const resultAsString = result.toString();

    return resultAsString ? `?${resultAsString}` : '';
  }, [whitelistedParams, searchParams]);
};
